export const normalizeSettingsSearch = (value: string): string => value.trim().toLowerCase()

/** `normalizedQuery` must come from {@link normalizeSettingsSearch}. */
export const labelIncludesSettingsSearch = (label: string, normalizedQuery: string): boolean => {
  if (!normalizedQuery) return true
  return normalizeSettingsSearch(label).includes(normalizedQuery)
}
